interface StarRatingProps {
  rating: number;
  className?: string;
  showValue?: boolean;
}

export default function StarRating({ rating, className = "", showValue = true }: StarRatingProps) {
  const stars = rating / 2;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className="flex items-center gap-0.5 text-accent-500">
        {[1, 2, 3, 4, 5].map((i) => {
          const icon =
            stars >= i - 0.25 ? "ri-star-fill" : stars >= i - 0.75 ? "ri-star-half-fill" : "ri-star-line";
          return <i key={i} className={`${icon} text-xs`} aria-hidden="true" />;
        })}
      </span>
      {showValue ? <span className="text-xs font-medium text-foreground-700">{rating.toFixed(1)}</span> : null}
    </span>
  );
}